export default __webpack_public_path__ + "static/media/airplane.4578574f.svg";